/**
 * Реквизиты продавца для Terms, Refund и Privacy. С 05.11.2026 на сайте только название продукта и почта поддержки:
 * тексты идут от «мы», подвал «© 2026 AI Administrator». Юридическое имя ИП, регистрационный номер, адрес
 * и применимое право пока пустые и в тексты не подставляются; когда Paddle попросит реквизиты, владелец заполняет
 * поля (имя ИП должно совпадать с данными в Paddle и Meta) и возвращает их во вступления и разделы «Контакты»
 * в `legal.ts`.
 */
export const SELLER = {
  productName: "AI Administrator",
  legalName: "",
  registration: "",
  address: "",
  email: "support@nekasoft.com",
  governingLaw: "",
} as const;

/** Пока юрист не проверил тексты, на страницах Terms, Refund и Privacy висит плашка «черновик». */
export const LEGAL_REVIEWED = false;

/** Дата последней редакции юридических текстов. */
export const LEGAL_UPDATED = "2026-11-05";
